import { render, staticRenderFns } from "./CorrosionColorRangeBar.vue?vue&type=template&id=064dfbbc&scoped=true"
import script from "./CorrosionColorRangeBar.vue?vue&type=script&lang=js"
export * from "./CorrosionColorRangeBar.vue?vue&type=script&lang=js"
import style0 from "./CorrosionColorRangeBar.vue?vue&type=style&index=0&id=064dfbbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064dfbbc",
  null
  
)

export default component.exports